// Module
import routes from './routes';
import deviceIdValidator from './device-id-validator';
import 'font-awesome-webpack';
import './styles.less';


export default angular.module('app.main.panel.module.device_add', [])
	.config(routes)
	.directive('deviceIdValidator', deviceIdValidator)
	.name;



/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/device_add/index.js
 **/